import { Agent, AgentDisplayName } from "@istari/istari-client";

function usableDisplayName(name: string | null | undefined, agentId: string): string | undefined {
  const trimmed = name?.trim();
  if (!trimmed || trimmed === agentId) {
    return undefined;
  }
  return trimmed;
}

function getCreatedTime(entry: AgentDisplayName): number | undefined {
  if (entry.created == null) {
    return undefined;
  }
  const time = new Date(entry.created).getTime();
  return Number.isNaN(time) ? undefined : time;
}

function getDisplayNameHistoryNewestFirst(history: AgentDisplayName[]): AgentDisplayName[] {
  if (history.every((entry) => getCreatedTime(entry) === undefined)) {
    return [...history].reverse();
  }

  return [...history].sort((a, b) => {
    const aTime = getCreatedTime(a);
    const bTime = getCreatedTime(b);

    if (aTime !== undefined && bTime !== undefined) {
      return bTime - aTime;
    }
    if (aTime !== undefined) {
      return -1;
    }
    if (bTime !== undefined) {
      return 1;
    }
    return 0;
  });
}

export function getAgentLatestDisplayName(agent: Agent) {
  const history = agent.displayNameHistory;
  if (!history?.length) {
    return agent.id;
  }

  const ordered = getDisplayNameHistoryNewestFirst(history);
  for (const entry of ordered) {
    const name = usableDisplayName(entry.displayName, agent.id);
    if (name) {
      return name;
    }
  }
  return agent.id;
}
